// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCgH6WDNZHcxv6h4bLmmIA7TGs76g8ANHs",
  authDomain: "digitab-fatehabad-v1.firebaseapp.com",
  projectId: "digitab-fatehabad-v1",
  storageBucket: "digitab-fatehabad-v1.firebasestorage.app",
  messagingSenderId: "446251069726",
  appId: "1:446251069726:web:d423adb2d8eb990c65590f",
  measurementId: "G-M6XKX7CNMP"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Initialize Google Auth Provider
export const googleProvider = new GoogleAuthProvider();

// Initialize Analytics (only in browser environment)
export const analytics = typeof window !== 'undefined' ? getAnalytics(app) : null;

export default app;

